import {} from '../../config';
import { faro } from '../../sdk/registerFaro';
import { TransportItemType } from '../../transports';
import { dateNow, genShortID, Observable, stringifyObjectValues } from '../../utils';
import { ItemBuffer } from '../ItemBuffer';
import {} from '../measurements';
import {} from '../types';
import { UserActionSeverity } from './const';
import { UserActionState } from './types';
const defaultFollowUpActionTimeRange = 100;
const defaultHaltTimeout = 10 * 1000;
export default class UserAction extends Observable {
    constructor({ name, parentId, haltTimeout, trigger, transports, attributes, trackUserActionsExcludeItem, severity = UserActionSeverity.Normal, }) {
        super();
        this.name = name;
        this.attributes = attributes;
        this.id = genShortID();
        this.trigger = trigger;
        this.cancelTimeout = defaultFollowUpActionTimeRange;
        this.haltTimeout = haltTimeout !== null && haltTimeout !== void 0 ? haltTimeout : defaultHaltTimeout;
        this.parentId = parentId !== null && parentId !== void 0 ? parentId : this.id;
        this.trackUserActionsExcludeItem = trackUserActionsExcludeItem;
        this.severity = severity;
        this._itemBuffer = new ItemBuffer();
        this._transports = transports;
        this._haltTimeoutId = -1;
        this._state = UserActionState.Started;
        this._isValid = false;
        this._start();
    }
    addItem(item) {
        this._itemBuffer.addItem(item);
    }
    extend(haltPredicate) {
        if (!this._isValid) {
            this._isValid = true;
        }
        this._setFollowupActionTimeout(haltPredicate);
    }
    _setFollowupActionTimeout(haltPredicate) {
        this._timeoutId = startTimeout(this._timeoutId, () => {
            if (this._state === UserActionState.Started && (haltPredicate === null || haltPredicate === void 0 ? void 0 : haltPredicate())) {
                this.halt();
            }
            else if (this._isValid) {
                this.end();
            }
            else {
                this.cancel();
            }
        }, defaultFollowUpActionTimeRange);
    }
    _start() {
        this._state = UserActionState.Started;
        if (this._state === UserActionState.Started) {
            this.startTime = dateNow();
        }
        this._setFollowupActionTimeout();
    }
    halt() {
        if (this._state !== UserActionState.Started) {
            return;
        }
        this._state = UserActionState.Halted;
        // If the halt timeout fires, we end the user action as
        // it is still a valid one.
        this._haltTimeoutId = setTimeout(() => {
            this.end();
        }, this.haltTimeout);
        this.notify(this._state);
    }
    cancel() {
        if (this._state === UserActionState.Started) {
            // Empty the buffer
            this._itemBuffer.flushBuffer();
        }
        this._state = UserActionState.Cancelled;
        this.notify(this._state);
    }
    end() {
        if (this._state === UserActionState.Cancelled) {
            return;
        }
        // Make sure we don't end the user action twice
        clearTimeout(this._haltTimeoutId);
        clearTimeout(this._timeoutId);
        const endTime = dateNow();
        const duration = endTime - this.startTime;
        this._state = UserActionState.Ended;
        this._itemBuffer.flushBuffer((item) => {
            if (isExcludeFromUserAction(item, this.trackUserActionsExcludeItem)) {
                this._transports.execute(item);
                return;
            }
            const userActionItem = Object.assign(Object.assign({}, item), { payload: Object.assign(Object.assign({}, item.payload), { action: {
                        parentId: this.id,
                        name: this.name,
                    } }) });
            this._transports.execute(userActionItem);
        });
        this._state = UserActionState.Ended;
        this.notify(this._state);
        faro.api.pushEvent(this.name, Object.assign({ userActionStartTime: this.startTime.toString(), userActionEndTime: endTime.toString(), userActionDuration: duration.toString(), userActionTrigger: this.trigger, userActionSeverity: this.severity }, stringifyObjectValues(this.attributes)), undefined, {
            timestampOverwriteMs: this.startTime,
            customPayloadTransformer: (payload) => {
                payload.action = {
                    id: this.id,
                    name: this.name,
                };
                return payload;
            },
        });
    }
    getState() {
        return this._state;
    }
}
function isExcludeFromUserAction(item, trackUserActionsExcludeItem) {
    return ((trackUserActionsExcludeItem === null || trackUserActionsExcludeItem === void 0 ? void 0 : trackUserActionsExcludeItem(item)) ||
        (item.type === TransportItemType.MEASUREMENT && item.payload.type === 'web-vitals'));
}
function startTimeout(timeoutId, cb, delay) {
    if (timeoutId) {
        clearTimeout(timeoutId);
    }
    //@ts-expect-error for some reason vscode is using the node types
    timeoutId = setTimeout(() => {
        cb();
    }, delay);
    return timeoutId;
}
//# sourceMappingURL=userAction.js.map